// extracted by css-extract-rspack-plugin
export default {"group":"group-my2whU"};